import gql from 'graphql-tag';
import CommonPatientInfo from './patientInfo';
import CommonSimpleAccount from './simpleAccount';
import CommonSimpleFacility from './simpleFacility';

export default gql`
  fragment CommonEncounter on Encounter {
    _id
    patientInfo {
      ...CommonPatientInfo
    }
    account {
      ...CommonSimpleAccount
    }
    facility {
      ...CommonSimpleFacility
    }
    pin
    reason
    status
    start
    end
    createdAt
  }
  ${CommonPatientInfo}
  ${CommonSimpleAccount}
  ${CommonSimpleFacility}
`;
